import { getLocalizedAttrValues, getLocalizedAttrValue } from '@grandvisionhq/utils';

const mapProductToFrameData = (product)=>{
    const gender = getLocalizedAttrValues(product.masterVariant, 'gender', 'en');
    const isKidsGlasses = gender.some((a)=>a.toLowerCase() === 'kids'
    );
    const framePrice = product.masterVariant.prices && product.masterVariant.prices[0].value.centAmount || 0;
    const brand = getLocalizedAttrValue(product.masterVariant, 'brand', 'en');
    return {
        brand,
        framePrice,
        gender,
        isKidsGlasses
    };
};

export { mapProductToFrameData };
//# sourceMappingURL=map-product-to-frame-data.js.map
